import { useState } from "react";
import Paper from "@mui/material/Paper";
import ToggleButton from "@mui/material/ToggleButton";
import ToggleButtonGroup from "@mui/material/ToggleButtonGroup";
import { styled } from "@mui/material/styles";

import { Profile } from "./Profile";
import { Operators } from "./Operators";
import { COLORS } from "../../utils/colors";
import { Memberships } from "./Memberships";
import { SmartContract } from "./SmartContract";
import { SoldMemberships } from "./SoldMemberships";

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  "& .MuiToggleButtonGroup-grouped": {
    margin: theme.spacing(0.5),
    border: 0,
    textTransform: "none",
    width: "fit-content",
    "&.Mui-disabled": {
      border: "1px solid ${COLORS.grey}",
    },
    "&:not(:first-of-type)": {
      borderRadius: theme.shape.borderRadius,
    },
    "&:first-of-type": {
      borderRadius: theme.shape.borderRadius,
    },
  },
}));

export const OrganizerPage = ({ userData, supabase, handleSnackbar }) => {
  const [tab, setTab] = useState("profile");
  const [dayPeriod, setDayPeriod] = useState(0);
  const changeTab = (event, newTab) => {
    newTab !== null && setTab(newTab);
  };

  const changeDayPeriod = async (event, newDayPeriod) => {
    if (newDayPeriod !== null) {
      setDayPeriod(newDayPeriod);
    }
  };

  return (
    <div className="standard-container-2">
      <div
        className="container-row"
        style={{
          width: "-webkit-fill-available",
          justifyContent: "space-between",
        }}
      >
        <Paper
          elevation={0}
          sx={{
            display: "flex",
            border: (theme) => `1px solid ${theme.palette.divider}`,
            width: "fit-content",
            flexWrap: "wrap",
          }}
        >
          <StyledToggleButtonGroup
            size="small"
            value={tab}
            exclusive
            onChange={changeTab}
            sx={{ color: COLORS.grey }}
          >
            <ToggleButton value="profile" selected={tab == "profile"}>
              <p style={{ fontSize: "14px", margin: "0px 20px" }}>
                Organization Profile
              </p>
            </ToggleButton>
            <ToggleButton value="operators" selected={tab == "operators"}>
              <p style={{ fontSize: "14px", margin: "0px 20px" }}>Operators</p>
            </ToggleButton>
            <ToggleButton value="memberships" selected={tab == "memberships"}>
              <p style={{ fontSize: "14px", margin: "0px 20px" }}>
                Memberships
              </p>
            </ToggleButton>
            <ToggleButton
              value="soldMemberships"
              selected={tab == "soldMemberships"}
            >
              <p style={{ fontSize: "14px", margin: "0px 20px" }}>
                Sold Memberships
              </p>
            </ToggleButton>
            {userData?.smart_contract_address && (
              <ToggleButton
                value="smartContract"
                selected={tab == "smartContract"}
              >
                <p style={{ fontSize: "14px", margin: "0px 20px" }}>
                  Smart Contract
                </p>
              </ToggleButton>
            )}
          </StyledToggleButtonGroup>
        </Paper>
        {tab === "soldMemberships" && (
          <Paper
            elevation={0}
            sx={{
              display: "flex",
              border: (theme) => `1px solid ${theme.palette.divider}`,
              flexWrap: "wrap",
            }}
          >
            <StyledToggleButtonGroup
              size="small"
              value={dayPeriod}
              exclusive
              onChange={changeDayPeriod}
            >
              <ToggleButton value="1" selected={dayPeriod == 1}>
                <p style={{ fontSize: "14px", margin: "0px 20px" }}>1D</p>
              </ToggleButton>
              <ToggleButton value="7" selected={dayPeriod == 7}>
                <p style={{ fontSize: "14px", margin: "0px 20px" }}>7D</p>
              </ToggleButton>
              <ToggleButton value="15" selected={dayPeriod == 15}>
                <p style={{ fontSize: "14px", margin: "0px 20px" }}>15D</p>
              </ToggleButton>
              <ToggleButton value="30" selected={dayPeriod == 30}>
                <p style={{ fontSize: "14px", margin: "0px 20px" }}>30D</p>
              </ToggleButton>
              <ToggleButton value="0" selected={dayPeriod == 0}>
                <p style={{ fontSize: "14px", margin: "0px 20px" }}>Total</p>
              </ToggleButton>
            </StyledToggleButtonGroup>
          </Paper>
        )}
      </div>
      {tab === "profile" && (
        <Profile
          userData={userData}
          handleSnackbar={handleSnackbar}
          supabase={supabase}
        />
      )}
      {tab === "operators" && <Operators userData={userData} />}
      {tab === "memberships" && (
        <Memberships
          userData={userData}
          supabase={supabase}
          handleSnackbar={handleSnackbar}
        />
      )}
      {tab === "smartContract" && <SmartContract userData={userData} />}
      {tab === "soldMemberships" && (
        <SoldMemberships
          userData={userData}
          handleSnackbar={handleSnackbar}
          dayPeriod={dayPeriod}
        />
      )}
    </div>
  );
};
